import React from 'react';
import completeIcon from '../../assets/complete.png';
import { workwiseServices } from '../../api';
import { useDispatch, useSelector } from 'react-redux';
import { setIsReadOnly } from '../../app/EditorSlice';
import { message, Modal, Tooltip } from 'antd';
import { CheckCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import './completeDoc.css';

const { confirm } = Modal;

const CompleteDocument = () => {
    const dispatch = useDispatch();
    const { referenceId } = useSelector((state) => state.editor.documentInformation);

    const handleClick = async () => {
        try {
            await workwiseServices.completeDocument(referenceId);
            message.success('Document completed successfully.');
            dispatch(setIsReadOnly(true));
        } catch (error) {
            message.error('Failed to complete the document. Please try again.');
        }
    };

    const showConfirmationModal = (e) => {
        e.preventDefault();
        confirm({
            className: 'complete-doc-confirm',
            icon: null,
            title: (
                <>
                    <span className="complete-doc-confirm__badge">
                        <ExclamationCircleOutlined />
                    </span>
                    <span className="complete-doc-confirm__title">Complete this document?</span>
                </>
            ),
            content: (
                <>
                    <p className="complete-doc-confirm__text">
                        Once completed, this document is locked. You won't be able to edit or reopen it.
                    </p>
                </>
            ),
            okText: (
                <>
                    <CheckCircleFilled />
                    Complete document
                </>
            ),
            okButtonProps: { type: 'primary' },
            closable: true,
            cancelText: 'Cancel',
            onOk() {
                handleClick();
            },
            onCancel() {
            },
            zIndex: 9999,
            maskClosable:true,
        });
    };

    return (
        <Tooltip title='Complete document'>
            <div
                style={{
                    marginLeft: "4px",
                    display: "flex",
                    cursor: 'pointer'
                }}
                onClick={(e) => showConfirmationModal(e)}
            >
                <img src={completeIcon} width={16} alt="Complete Document" />
            </div>
        </Tooltip>
    );
};

export default CompleteDocument;
